import { render, staticRenderFns } from "./export.vue?vue&type=template&id=5c222c9c&scoped=true&"
import script from "./export.vue?vue&type=script&lang=ts&"
export * from "./export.vue?vue&type=script&lang=ts&"
import style0 from "./export.vue?vue&type=style&index=0&id=5c222c9c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c222c9c",
  null
  
)

export default component.exports